import axios from 'axios';

import {
    staffRequest,
    staffFail,
    staffListSuccess,
    singleStaffSuccess,
    newStaffSuccess,
    updateStaffSuccess,
    deleteStaffSuccess
} from '../slices/staffSlice';

export const getAllStaff = () => async (dispatch) => {
    try {
        dispatch(staffRequest());
        const { data } = await axios.get(`/api/v1/admin/staff`);
        dispatch(staffListSuccess(data));
    } catch (error) {
        dispatch(staffFail(error.response.data.message));
    }
}

export const getStaff = id => async (dispatch) => {
    try {
        dispatch(staffRequest());
        const { data } = await axios.get(`/api/v1/admin/staff/${id}`);
        dispatch(singleStaffSuccess(data));
    } catch (error) {
        dispatch(staffFail(error.response.data.message));
    }
}

export const getSingleStaff = getStaff;

export const createStaff = formData => async (dispatch) => {
    try {
        dispatch(staffRequest());
        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        const { data } = await axios.post(`/api/v1/admin/staff/new`, formData, config);
        dispatch(newStaffSuccess(data));
    } catch (error) {
        dispatch(staffFail(error.response.data.message));
    }
}

export const updateStaff = (id, formData) => async (dispatch) => {
    try {
        dispatch(staffRequest());
        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        const { data } = await axios.put(`/api/v1/admin/staff/${id}`, formData, config);
        dispatch(updateStaffSuccess(data));
    } catch (error) {
        dispatch(staffFail(error.response.data.message));
    }
}

export const deleteStaff = id => async (dispatch) => {
    try {
        dispatch(staffRequest());
        await axios.delete(`/api/v1/admin/staff/${id}`);
        dispatch(deleteStaffSuccess());
    } catch (error) {
        dispatch(staffFail(error.response.data.message));
    }
}
